export default __webpack_public_path__ + "static/media/isfj@3x.efa64868.png";